export const GET_APPOINTMENT_SLOTS_ENDPOINT = (
  jobId: number,
  workerId: number,
  companyId: number,
) => `appointment/appointment-slot?jobId=${jobId}&workerId=${workerId}&companyId=${companyId}`;

export const CREATE_APPOINTMENT_ENDPOINT = 'appointment';
